<script>
  import { SPRITESHEET_URL } from '../../utils/constants.ts';
  import BaseHeading from '../BaseHeading/BaseHeading.svelte';
  import BaseLink from '../BaseLink/BaseLink.svelte';
  import { getPath } from '../../utils/imageKit.ts';

  let {
    icon = undefined,
    caption = undefined,
    headingText,
    headingLevel = 'h2',
    links = [],
    dataTestId = 'content-link-box',
  } = $props();

  // Handle Image Setup
  const defaultSrc = getPath(icon, { h: 128, ar: '4:3' });
  const highResSrc = getPath(icon, { h: 128, ar: '4:3' }, 2);
</script>

<div class="w-full flex flex-col" data-testid={dataTestId}>
  <div class="bg-blue-cerulean flex flex-row justify-between items-center min-h-22">
    <div class="flex flex-col items-start justify-center px-6">
      {#if caption}
        <div class="mb-1 text-sm leading-normal text-white uppercase">{caption}</div>
      {/if}
      <BaseHeading className="leading-tight font-medium text-white lg:text-xl" {headingLevel}>
        {headingText}
      </BaseHeading>
    </div>
    {#if icon && icon.url && icon.alt}
      <div class="h-32 w-auto">
        <img
          class="object-contain object-right h-full w-auto"
          loading="lazy"
          src={defaultSrc}
          alt={icon.alt}
          height="128"
          width="171"
          srcset={`${defaultSrc}, ${highResSrc} 2x`}
          sizes="(min-width: 640px) 192px, 130px"
        />
      </div>
    {/if}
  </div>
  {#if links.length}
    <div class="px-4 lg:px-6 pt-6 pb-2 flex flex-col justify-start">
      {#each links as { text, url, target }}
        {#if text && url}
          <div class="w-full">
            <BaseLink
              className="text-sm leading-normal font-medium text-blue-cerulean lg:text-xl hover-hover:hover:text-blue-darkish
              hover-hover:hover:underline active:text-blue-darkish active:underline group inline-flex justify-start flex-row w-auto mb-4 lg:mb-5"
              {url}
              {target}
            >
              <span>{text}</span>
              <svg
                class="ml-3 h-3 w-3 lg:h-5 lg:w-5 mt-1 lg:mt-1.25 fill-current text-blue-cerulean
                hover-hover:group-hover:text-blue-darkish group-active:text-blue-darkish"
              >
                <use xlink:href={`${SPRITESHEET_URL}#right-arrow`} />
              </svg>
            </BaseLink>
          </div>
        {/if}
      {/each}
    </div>
  {/if}
</div>
